import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { CamService } from 'src/app/services/camService/cam.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf, NgFor } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { ContentService } from '../../services/content.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';


@Component({
    selector: 'app-uploaded-files-dialog',
    templateUrl: './uploaded-files-dialog.component.html',
    styleUrls: ['./uploaded-files-dialog.component.scss'],
    imports: [MatIconButton, MatIcon, MatButton, CdkScrollable, MatDialogContent, NgIf, NgFor]
})



export class UploadedFilesDialogComponent implements OnInit {
  displayData: any[] = [];
  failedUsers: any[] = [];
  failedCount: number = 0;
  totalRecords: number = 0;
  displayLimit: number = 50;
  content:any;
  companyManagementContent:any;
  private destroy$ = new Subject<void>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<UploadedFilesDialogComponent>,
    public _CamService: CamService, // Inject MatDialogRef
    private contentService:ContentService,
    private readonly companyManagementService: CompanyManagementContentService
  ) {
  }


  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
        this.content = res;
      });

    this.companyManagementService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.companyManagementContent = res;
    });

    if (this.data && this.data.failedUsers) {
      this.failedUsers = this.data.failedUsers;
      this.failedCount = this.data.failedCount || 0;
      this.totalRecords = this.data.totalRecords || 0;
    } else {
      this.failedUsers = Array.isArray(this.data) ? this.data : [];
      this.failedCount = this.failedUsers.length;
      this.totalRecords = this.failedUsers.length;
    }
    
    this.updateDisplayData();
  }

  updateDisplayData(): void {
    this.displayData = this.failedUsers.slice(0, this.displayLimit);
  }

  loadMore(): void {
    this.displayLimit += 50;
    this.updateDisplayData();
  }

  hasMoreData(): boolean {
    return this.displayLimit < this.failedUsers.length;
  }

  getFailedProfilesText(): string {
    const template = this.content?.['b2b.managetraveler.nooferrorfiles']
      || '{nooferrorfiles} out of {totalfiles} profiles were not uploaded.';
    return template
      .replace('{nooferrorfiles}', String(this.failedCount ?? 0))
      .replace('{totalfiles}', String(this.totalRecords ?? 0));
  }

  getReasonBadgeClass(reason: string): string {
    if (!reason) return 'badge-error';
    const lowerReason = reason.toLowerCase();
    
    if (lowerReason.includes('already exists')) {
      return 'badge-error';
    } else if (lowerReason.includes('api failed') || lowerReason.includes('3rd party')) {
      return 'badge-warning';
    } else if (lowerReason.includes('validation')) {
      return 'badge-yellow';
    }
    
    return 'badge-error'; // Default
  }

  closeDialog(): void {
    this.dialogRef.close();  // Closes the dialog
    this._CamService.notifyDialogClosed(true);
  }

downloadExcel(): void {
    const data = this.failedUsers;

    if (!data || !data.length) {
      alert('No data available to download');
      return;
    }

    const csv = this.convertToCSV(data);
    this.triggerDownload(csv, 'report.csv');
  }

  convertToCSV(data: any[]): string {
    const headers = Object.keys(data[0]).join(',');

    const rows = data.map(row =>
      Object.values(row)
        .map(val => `"${val ?? ''}"`)
        .join(',')
    );

    return `${headers}\n${rows.join('\n')}`;
  }

  triggerDownload(csv: string, fileName: string): void {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();

    window.URL.revokeObjectURL(url);
  }
}


